import { ref, computed } from 'vue';

export default function useFieldValidation() {
  interface ValidationField {
    value: unknown;
    error: boolean;
    rule: null | ((value: unknown) => boolean);
  }

  const validationFields = ref<ValidationField[]>([]);

  const validation = (value: unknown, rule: null | ((value: unknown) => boolean) = null) => {
    const index = validationFields.value.push({ 
      value, 
      error: false,
      rule
    }) - 1;

    return computed(() => !validationFields.value[index]?.error);
  };

  const validateAll = () => {
    validationFields.value.forEach((element) => {
      const { value } = element;
      if (!value) {
        element.error = true;
      } else if (element.rule && !element.rule(value)) {
        element.error = true;
      } else {
        element.error = false;
      }
    });
  };

  const allFieldsValid = computed(() => !validationFields.value.some((element) => element.error));

  return { validation, validateAll, allFieldsValid };
}
